export const getEmbeddedFrameSource = (source) => {
	const html = String(source || '').trim()
	if (!html) return null

	try {
		const directUrl = new URL(html)
		if (['http:', 'https:'].includes(directUrl.protocol)) {
			return { src: directUrl.toString() }
		}
	} catch {
		// Source is HTML rather than a direct URL.
	}

	if (typeof DOMParser !== 'undefined') {
		const document = new DOMParser().parseFromString(html, 'text/html')
		const embeddedIframe = document.querySelector('iframe[src]')
		const iframeSource = embeddedIframe?.getAttribute('src')
		if (iframeSource) {
			try {
				const iframeUrl = new URL(iframeSource, window.location.href)
				if (['http:', 'https:'].includes(iframeUrl.protocol)) {
					return { src: iframeUrl.toString() }
				}
			} catch {
				// Invalid iframe URLs fall back to isolated srcDoc rendering.
			}
		}
	}

	return {
		srcDoc: `<!doctype html>
<html>
	<head>
		<meta charset="utf-8" />
		<meta name="viewport" content="width=device-width, initial-scale=1" />
		<style>
			html, body { width: 100%; height: 100%; margin: 0; }
			iframe { width: 100% !important; height: 100% !important; min-height: 100vh; border: 0; }
		</style>
	</head>
	<body>${html}</body>
</html>`,
	}
}

const isIOSDevice = () => {
	if (typeof navigator === 'undefined') return false

	return (
		/iPad|iPhone|iPod/.test(navigator.userAgent) ||
		(navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
	)
}

const isNotionUrl = (value) => {
	try {
		const hostname = new URL(value).hostname.toLowerCase()
		return ['notion.com', 'notion.so', 'notion.site'].some(
			(domain) => hostname === domain || hostname.endsWith(`.${domain}`),
		)
	} catch {
		return false
	}
}

export const openEmbeddedPageInNewTab = (frameSource) => {
	if (isIOSDevice() && frameSource?.src && isNotionUrl(frameSource.src)) {
		window.open(frameSource.src, '_blank', 'noopener,noreferrer')
		return true
	}

	return false
}
